import { useState } from "react";
import axios from "axios";
import useAxios from "../../hooks/useAxios";

const useEmployeeService = () => {
  const axiosGetAllEmployees = useAxios();
  const axiosAddEmployee = useAxios();
  const axiosEditEmployee = useAxios();
  const axiosAddBulkEmployees = useAxios();
  const axiosDeleteEmployee = useAxios();

  const [exportLoading, setExportLoading] = useState(false);

  const getAllEmployees = async (search) => {
    const query = search ? `?search=${encodeURIComponent(search)}` : "";
    await axiosGetAllEmployees.fetchData({
      url: `/admin/employee${query}`,
      method: "GET",
    });
  };

  const addEmployee = async (data) => {
    const result = await axiosAddEmployee.fetchData({
      url: `/admin/employee/add`,
      method: "POST",
      data,
    });
    return result;
  };

  const editEmployee = async (data) => {
    const result = await axiosEditEmployee.fetchData({
      url: `/admin/employee/edit`,
      method: "POST",
      data,
    });
    return result;
  };

  const deleteEmployee = async (id) => {
    const result = await axiosDeleteEmployee.fetchData({
      url: `/admin/employee/delete/${id}`,
      method: "POST",
    });
    return result;
  };

  const addEmployeesBulk = async (data) => {
    const result = await axiosAddBulkEmployees.fetchData({
      url: `/admin/employee/add-bulk`,
      method: "POST",
      data,
    });
    return result;
  };

  const exportEmployees = async () => {
    setExportLoading(true);
    try {
      const token = localStorage.getItem("api_token");

      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/admin/employee/export`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      );

      const today = new Date().toISOString().split("T")[0];
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `pivot_employee_masterlist_${today}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setExportLoading(false);
    }
  };

  return {
    // list
    getAllEmployees,
    employeeLoading: axiosGetAllEmployees.loading,
    employeeResponse: axiosGetAllEmployees.response,

    // add
    addEmployee,
    addEmployeeLoading: axiosAddEmployee.loading,
    addEmployeeResponse: axiosAddEmployee.response,

    // edit
    editEmployee,
    editEmployeeLoading: axiosEditEmployee.loading,
    editEmployeeResponse: axiosEditEmployee.response,

    // bulk add
    addEmployeesBulk,
    addEmployeesBulkLoading: axiosAddBulkEmployees.loading,
    addEmployeesBulkResponse: axiosAddBulkEmployees.response,

    // delete
    deleteEmployee,
    deleteEmployeeLoading: axiosDeleteEmployee.loading,

    // export
    exportEmployees,
    exportLoading,
  };
};

export default useEmployeeService;
